// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
import zhCN from '@/assets/i18n/zh';
import enUS from '@/assets/i18n/en';
import 'assets/lib/reset.css'

Vue.config.productionTip = false

Vue.use(VueI18n)

document.body.addEventListener('touchstart', function () { });
function getLang() {
    const reg = /Accept-Language\/([^;\s]+)/i;
    const _ua = window.navigator.userAgent.toLowerCase();
    const langMatch = _ua.match(reg);
  let lang = langMatch && langMatch[1].trim()
    // || navigator.language || navigator.userLanguage
    || 'zh-CN';
    if (lang.toLowerCase() === 'zh-cn') {
        lang = 'zh-CN';
    } else {
        lang = 'en-US';
    }
    return lang;
}
let locale = getLang();
console.log('test===>locale', locale);
const i18n = new VueI18n({
  locale,
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS
  }
});

//  vue  {{ $t('common') }}


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  template: '<App/>',
  components: { App }
})





// WEBPACK FOOTER //
// ./src/main.js